import serviceApi from '@/api/service/serviceApi'
import Service from '@/classes/case/Service'

const state = {
  services: []
}

const getters = {
  getActiveServices: state => {
    return state.services.filter(service => {
      return service.appliedQualifications.length > 0
    })
  },
  getInactiveServices: state => {
    return state.services.filter(service => {
      if (service.hasNoQualifications && service.appliedQualifications.length === 0) {
        return true
      }
      return service.availableQualifications.length > 0
    })
  },
  getAppliableServices: state => {
    return state.services.filter(service => {
      return service.appliable === true
    })
  }
}

const mutations = {
  setStateServices: (state, services) => {
    state.services = services
  },
  addToStateServices: (state, service) => {
    state.services.push(service)
  },
  updateStateServices: (state, data) => {
    data.current.updateCurrentService(data.updated)
  }
}

const actions = {
  getServices ({ commit }) {
    return serviceApi.getServices().then((response) => {
      let services = Service.asServices(response.data)
      commit('setStateServices', services)
      return true
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
